import React, { useState, useEffect, useRef } from "react";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import JoditEditor from "jodit-react";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { toast } from "react-toastify";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { slugGenerator } from "../../../components/CommonMethod/CommonMethods";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from "../../../CustomFields/saveCustomFieldsStrict";
import { useMyContext } from "../../../components/Provider/CommonProvider";

function AddPages() {
  const { fetchRequest, globalImageUplaodAPI } = useMyContext()

  const baseURL = process.env.REACT_APP_Baseurl
  const headers = getItemToken('access_token')
  const { id } = useParams()
  const navigate = useNavigate()

  const labelSource = 'page-setting'

  const createApi = `${baseURL}/admin/page/create`
  const addApi = `${baseURL}/admin/page/store`
  const editApi = `${baseURL}/admin/page/edit`
  const updateApi = `${baseURL}/admin/page/update`
  const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`
  const imageApi = globalImageUplaodAPI()



  const combinedRef = useRef({
    title: null,
    slug: null,
    body: null,
  });

  const [formData, setFormData] = useState({
    state: "formData",
    title: "",
    slug: "",
    body: "",
    active: 0,
    footer_active: 0,
    banner: 0
  })
  const [formDataError, setFormDataError] = useState({ body: "" })
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [coverImageFile, setCoverImageFile] = useState(null);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false);
  const [loading, setLoading] = useState(true);
  const [customFieldValues, setCustomFieldValues] = useState({});
  const [defaultOption, setDefaultOption] = useState({
    state: "defaultOption",
    settingsOption: {},
    pagesOption: [],
  })

  const handleClearSelectFile = (value) => {
    if (value == 'image') {
      setCoverImageFile(null)
    }
    setFormDataError((prev) => ({
      ...prev,
      [value]: ""
    }))

  }

  const validateImageRatio = (file, expectedRatio, expectedWidth, expectedHeight) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        const width = img.width;
        const height = img.height;
        const ratio = width / height;
        const expectedRatioPrecision = 0.01;
        const ratioMatch = Math.abs(ratio - expectedRatio) < expectedRatioPrecision;
        const dimensionMatch = (width === expectedWidth && height === expectedHeight);
        if (ratioMatch || dimensionMatch) {
          resolve(true);
        } else {
          resolve(false);
        }
      };
      img.onerror = () => {
        reject(new Error('Error loading image'));
      };
    });
  };

  const handleFileChange = async (event) => {
    const { files, name } = event.target;
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];

    if (files?.length > 0) {
      const newFile = files[0];

      // ✅ Check the file type before doing anything else
      if (!allowedTypes.includes(newFile.type)) {
        setFormDataError((prev) => ({
          ...prev,
          [name]: "Only JPG, JPEG, and PNG files are allowed.",
        }));
        return;
      }

      // ✅ Passed all checks
      setCoverImageFile(newFile);
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`${editApi}/${id}`, { headers: headers });
      const result = response?.data?.Page;
      setFormData(result)
      setLoading(false)
    } catch (error) {
      console.error(error);
    }
  };
  const fetchCreate = async () => {
    try {
      const response = await axios.get(`${createApi}`, { headers: headers });
      const result = response?.data;
      const defaultoptionslist = {
        settingsOption: result?.settings || {},
        pagesOption: result?.pages || []
      }
      setDefaultOption(defaultoptionslist);
      setLoading(false)
    } catch (error) {
      console.error(error);
    }
  };
  const labelFetch = async () => {
    try {
      setShowOverlay(true)
      const response = await axios.get(`${labelApi}`, { headers: headers });
      const result = response?.data?.label_management
      setLabelDisplay(result)
      setShowOverlay(false)
    }
    catch (err) {
      setShowOverlay(false)
      toast.error(err.response.data.message)

    }
  }

  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked ? 1 : 0,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }

  };

  const handleBlurtitle = () => {
    if (!formData?.slug) {
      generateSlug(formData?.title);
    }
  };

  const generateSlug = async (title) => {
    const slug = await slugGenerator(title)
    setFormData((prev) => ({
      ...prev,
      'slug': slug,
    }));
  };

  const handleInputKeyDowntitle = (event) => {
    if (!formData?.slug) {
      if (event.key === "Enter" || event.key === "Tab") {
        generateSlug(formData?.name);
      }
    }
  };

  const formValidation = () => {
    let formIsValid = true;
    if (!formData?.title) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        title: "Title cannot be empty.",
      }));
      combinedRef.current['title'].focus()
      formIsValid = false;
    } else if (!formData?.slug) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        slug: "Slug cannot be empty.",
      }));
      combinedRef.current['slug'].focus()
      formIsValid = false;
    }
    if (!formData?.body) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        body: "Page content cannot be empty.",
      }));
      combinedRef.current['body'].focus()
      formIsValid = false;
    }
    return formIsValid;
  }

  const handleFileUpload = async (id, name) => {
    try {
      const formDataAdd = new FormData();
      const modelName = "Page";
      if (name == 'video-image') {
        formDataAdd.append('page_id', id)
        formDataAdd.append('image', coverImageFile)
        formDataAdd.append("id", id);
        formDataAdd.append("modelName", modelName);
        formDataAdd.append('imageFields[]', 'image')
        const response = await fetchRequest({
          method: 'POST',
          url: imageApi,
          data: formDataAdd,
        });
      }
      setCoverImageFile(null)
    } catch (err) {
      toast.error(err?.response?.data?.message)
    }
  }

  const handleAdd = async () => {
    const findApi = !id ? addApi : `${updateApi}/${id}`
    const method = !id ? 'POST' : 'POST';
    setShowOverlay(true);
    try {
      const formDataAdd = {};
      for (const key in formData) {
        if (["title", "slug", "body", "active", "banner", "footer_active"].includes(key)) {
          formDataAdd[key] = formData[key]
        }
      }
      const response = await axios({ method: method, url: findApi, data: formDataAdd, headers: headers, });
      const result = response?.data;
      if (result?.status) {
        // save custom field values (strict)
        try {
          await saveCustomFieldsStrict({ baseURL, headers, entityType: 'page', entityId: result?.id || id, values: customFieldValues });
        } catch (e) {
          toast.error(e?.message || 'Failed to save additional fields');
          setShowOverlay(false);
          return;
        }
        if (coverImageFile) {
          await handleFileUpload(result?.id, 'video-image')
        }
        setShowOverlay(false);
        toast.success(result?.message)
        if (!id) {
          navigate("/pages");
        }
        else {
          setWithOutRefresh(!withOutRefresh)
        }
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
      console.error("error", err)
    }
  }

  const handleStore = (e) => {
    e.preventDefault()
    if (formValidation()) {
      handleAdd()
    }
  }

  useEffect(async () => {
    if (id) {
      await fetchData();
    }
    else {
      await fetchCreate()
    }
    await labelFetch()

  }, [withOutRefresh]);

  return (
    <>
      <AdminBackNavigation path="/pages" text="Back" />
      {showOverlay && (<Response_Processing></Response_Processing>)}
      <AdminSaveHeader heading={!id ? labelDisplay?.[1]?.title : labelDisplay?.[2]?.title} saveText={!id ? labelDisplay?.[1]?.title : labelDisplay?.[2]?.title} saveMethod={handleStore} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={!id ? labelDisplay?.[3]?.title : formData?.title} />
            <MessageLabel text={labelDisplay?.[4]?.title} className="mandatorySimple" />
            <AdminCustomInput type="text" name="title" value={formData?.title} onChange={handleInput} placeHolder={"Title"} ref={(el) => (combinedRef.current.title = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.title} />

            <MessageLabel text={labelDisplay?.[5]?.title} />
            <AdminCustomInput type="text" name="slug" value={formData?.slug} ref={(el) => (combinedRef.current.slug = el)} onChange={handleInput} placeHolder={"Slug"} error={formDataError?.slug} />

            <MessageLabel text={labelDisplay?.[6]?.title} />
            <JoditEditor className={`mb-3 custom-jodit`} ref={(el) => (combinedRef.current.body = el)} value={formData?.body} onChange={(newContent) => { setFormData(prev => ({ ...prev, body: newContent })); setFormDataError(prev => ({ ...prev, body: "" })); }} />
            {formDataError?.body && (<MessageBox text={`${formDataError?.body}`} classname='errorred mb-2 d-block' />)}

            <div className="card p-3 mt-3">
              {/* <MessageHeading text="Additional Fields" /> */}
              {/* Custom fields */}
              <FieldRenderer2
                pageIdentifier={id ? "pages.edit" : "pages.create"}
                entityType="page"
                entityId={id}
                text="Additional Fields"
              />
              <FieldRenderer
                pageIdentifier={id ? "pages.edit" : "pages.create"}
                entityType="page"
                entityId={id}
                onChange={setCustomFieldValues}
              />
            </div>

          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={labelDisplay?.[7]?.title} />
            <MessageLabel text={labelDisplay?.[8]?.title} />
            <AdminImageUploadZone
              onChange={handleFileChange}
              selectedFile={coverImageFile}
              uploadedImage={formData?.image}
              onDelete={handleClearSelectFile}
              ref={(el) => (combinedRef.current.image = el)}
              name="image"
              id={id}
              error={formDataError?.image}
            />
          </Wrapper>
          <Wrapper>
            <MessageHeading text={labelDisplay?.[9]?.title} />
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={labelDisplay?.[10]?.title} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'active'} checked={formData?.active == 1} onChange={handleInput} />
              </div>
            </div>

            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={labelDisplay?.[11]?.title} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'footer_active'} checked={formData?.footer_active == 1} onChange={handleInput} />
              </div>
            </div>
          </Wrapper>
        </RightWrapper>
        <AdminCustomButton className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={!id ? labelDisplay?.[1]?.title : labelDisplay?.[2]?.title} />
      </FormContainer>
    </>
  );
}

export default AddPages;